import {ScreenProp} from 'src/app/models'
import {DepartemenScreen} from '../page/departemen/Screen'
import {OrganizationScreen} from '../page/organization/Screen'
import {PerusahaanScreen} from '../page/perusahaan/Screen'

const AdministrationScreens: Record<string, ScreenProp> = {
  ADMINISTRATION: {
    PATH: '/administration',
    TITLE: 'Manajemen Klien',
    TITLE_ALT: 'Client Management',
  },

  ...OrganizationScreen,
  ...PerusahaanScreen,
  ...DepartemenScreen,
}

export default AdministrationScreens
